import { rest } from 'msw';
import overrideMapping from './api';

import { getApiEndpoint } from './utils/baseUrls';
import { mockResponse } from './utils/responseResult';

// URL 參數對應的覆蓋設定
// 範例：http://localhost:3001/index?delay=3000&override=apiEndpoint&type=error&scenario=E0102_001&scenarioOnce=default

export const getOverrideHandlers = ({ overrideKey, type, scenario, delayMs = 0, once = false }) => {
  const pageMapping = overrideMapping[overrideKey];
  console.log(getApiEndpoint(`${overrideKey}`));

  if (!pageMapping) return [];

  const scenarios = pageMapping[type];
  if (!scenarios) return [];

  const scenarioData = scenarios[scenario];
  if (!scenarioData) return [];

  return [
    rest.post(getApiEndpoint(`${overrideKey}`), async (req, res, ctx) => {
      if (delayMs) await new Promise((r) => setTimeout(r, delayMs));

      const result = mockResponse(
        scenarioData,
        type === 'success',
        type === 'error' ? scenarioData.processResult : undefined
      );

      if (once) return res.once(ctx.json(result));

      return res(ctx.json(result));
    }),
  ];
};

/**
 * 根據 URL 參數，對指定 API 做覆蓋
 * @param {import('msw/browser').SetupWorker} worker
 */
export const applyOverrides = (worker) => {
  const urlParams = new URLSearchParams(window.location.search);
  const overrideKey = urlParams.get('override'); //"apiEndpoint"
  const type = urlParams.get('type'); //"success" 或 "error"
  const scenarioKey = urlParams.get('scenario'); //"default" 或 "E001"
  const scenarioOnce = urlParams.get('scenarioOnce'); // 僅執行一次
  const delayMs = urlParams.get('delay'); //"3000"

  if (!overrideKey || !type || !scenarioKey) return;

  const handlers = getOverrideHandlers({ overrideKey, type, scenario: scenarioKey, delayMs });
  console.log('@@@', handlers);
  worker.use(...handlers);

  console.log(`[MSW] Override Applied → ${overrideKey}: ${type}.${scenarioKey}`);

  if (scenarioOnce) {
    const handlers = getOverrideHandlers({ overrideKey, type, scenario: scenarioOnce, delayMs, once: true });
    worker.use(...handlers);
  }
};
